// extracted by mini-css-extract-plugin
export default {"tech":"igQtVQK3jANy8aZwKOum","icon-svg":"L3Go7TUl6WCXsE3D0NlR"};